import {FC, memo, useEffect} from 'react'
import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {orderSelector, setCustomerFilter as setFilter} from '../../../redux/slices/orderSlices'
import {TCustomer} from '../../../redux/types'
import Pagination from '../component/Pagination'
import * as TableUI from '../../../components/Table/Table'

interface TableBrowseCustomersProps {
  customers: TCustomer[]
  paginateNumber: any
  numberURL: string[]
  onSelectCustomer: (item: TCustomer) => void
}

// eslint-disable-next-line react/display-name
export const TableBrowseCustomers = memo((props: TableBrowseCustomersProps) => {
  const {t} = useTranslation()
  const {customerFilter: filter} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(setFilter({...filter, customer_code: '', name: ''}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TableUI.TableWrapper>
      <TableUI.Table>
        <TableUI.THead>
          <tr>
            <th>Checked</th>
            <th>{t('Customer Code')}</th>
            <th>{t('Customer Name')}</th>
          </tr>
        </TableUI.THead>
        <TableUI.TBody>
          {/* RowFilter */}
          <TableUI.TRowFilter>
            <td>
              <div></div>
            </td>
            <td>
              <TextInputV2
                placeholder={t('Customer Code')}
                value={filter?.customer_code ?? ''}
                onChange={({target}) =>
                  dispatch(setFilter({...filter, customer_code: target.value}))
                }
              />
            </td>
            <td>
              <TextInputV2
                placeholder={t('Customer Name')}
                value={filter?.name ?? ''}
                onChange={({target}) => dispatch(setFilter({...filter, name: target.value}))}
              />
            </td>
          </TableUI.TRowFilter>

          {/* RowData */}
          {props.customers?.map((item, index) => {
            return (
              <tr key={item?.customer_code ?? index}>
                <td>
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Form.Check
                      reverse
                      type='checkbox'
                      id={item?.customer_code}
                      onChange={() => props.onSelectCustomer(item)}
                    />
                  </div>
                </td>
                <td>
                  <span>{item.customer_code}</span>
                </td>
                <td>
                  <span>{item.name}</span>
                </td>
              </tr>
            )
          })}
        </TableUI.TBody>
      </TableUI.Table>

      <div className='my-5'>
        <Pagination paginate={props.paginateNumber} test={props.numberURL} />
      </div>
    </TableUI.TableWrapper>
  )
})
